<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="8"
        order="2"
        order-md="1"
        class="mb-4 mb-md-0 pt-4 pt-md-0"
      >
        <v-card class="mb-5 mt-3">
          <CollapseItems>
            <template #title>
              <div class="mr-2">
                Minha jornada nos ciclos
              </div>
            </template>
            <template #content>
              <CycleRow
                v-for="(cycle, key) in cycles"
                :key="key"
                :cycle="cycle"
                :class="{
                  'border-bottom' : cycle.order < 8
                }"
              />
            </template>
          </CollapseItems>
        </v-card>
        <WeekCalendar v-show="isMobile" />
      </v-col>
      <v-col
        cols="12"
        lg="4"
        sm="12"
        order-md="2"
        order="1"
      >
        <Notices v-if="current_cycle" />
        <Revision v-if="showRevision" />
        <WeekCalendar v-show="!isMobile" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import WeekCalendar from "./components/WeekCalendar";
import { mapActions, mapGetters, mapMutations} from "vuex";
import Notices from "@/student/components/Notice";
import CollapseItems from "@/common/components/CollapseItems.vue";
import Revision from "@/student/components/Revision";
import ResetYear from "@/student/mixins/resetYear"
import CycleRow from './components/CycleRow.vue';

export default {
  components: {
    Revision,
    WeekCalendar,
    Notices,
    CollapseItems,
    CycleRow,
  },
  mixins:[ResetYear],
  computed: {
    ...mapGetters(['current_cycle','selectedCycle','count_challenges','cycles']),
    showRevision(){
      return this.$moment().year() == 2022 && this.count_challenges > 0;
    }
  },
  created() {
    if(!this.selectedCycle){
      this.SET_CYCLE(this.current_cycle)
    }
    this.SHOW_WARNINGS();
    this.getCycles()
  },
  methods:{
    ...mapMutations(['SHOW_WARNINGS','SET_CYCLE']),
    ...mapActions(['getCycles'])
  },
}
</script>
